module.exports = __webpack_public_path__ + "static/media/memorial_icon.058a6a82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/configurator/memorial_icon.png
// module id = 1593
// module chunks = 0